import React from "react";

const Modal = ({ children, onClose }) => (
  <div
    className="modal is-active"
    style={{ zIndex: 1000, background: "rgba(0,0,0,0.4)" }}
  >
    <div className="modal-background" onClick={onClose}></div>
    <div className="modal-content" style={{ maxWidth: 600, margin: "auto" }}>
      <div
        className="box"
        style={{ borderRadius: 12, boxShadow: "0 2px 16px rgba(0,0,0,0.15)" }}
      >
        {children}
      </div>
    </div>
    <button
      className="modal-close is-large"
      aria-label="close"
      onClick={onClose}
      style={{ outline: "none" }}
    ></button>
  </div>
);

export default Modal;
